export default {
  i18n: {
    messages: {
      uk: {
        'Виїзна перевірка авто у вашому місті': 'Виїзна перевірка авто у вашому місті',
      },
      ru: {
        'Виїзна перевірка авто у вашому місті': 'Выездная проверка авто в вашем городе',
      },
    },
  },
};
